import { Leaf } from "lucide-react"
import { useEffect, useState } from "react"

export default function Preloader({ onComplete }) {
  const [progress, setProgress] = useState(0)
  const [currentMessage, setCurrentMessage] = useState(0)

  const messages = [
    "Preparing your skincare and hair care journey...",
    "Loading premium products...",
    "Setting up your glow...",
    "Almost ready for a healthy ravishing skin and hair...",
  ]

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(progressInterval)
          setTimeout(() => onComplete && onComplete(), 500)
          return 100
        }
        return prev + 2
      })
    }, 50)

    const messageInterval = setInterval(() => {
      setCurrentMessage((prev) => (prev + 1) % messages.length)
    }, 1200)

    return () => {
      clearInterval(progressInterval)
      clearInterval(messageInterval)
    }
  }, [onComplete])

  return (
    <div className="fixed inset-0 bg-gradient-to-br from-primary to-primary/90 flex items-center justify-center z-50">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-32 h-32 bg-secondary rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-32 right-32 w-48 h-48 bg-secondary rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/3 w-24 h-24 bg-white rounded-full blur-2xl animate-pulse delay-500"></div>
      </div>

      <div className="text-center z-10">
        {/* Logo Animation */}
        <div className="mb-8">
          <div className="relative">
            {/* Outer Ring */}
            <div className="w-24 h-24 border-4 border-secondary/30 rounded-full animate-spin mx-auto mb-4"></div>

            {/* Inner Logo */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-16 h-16 bg-secondary rounded-full flex items-center justify-center animate-pulse">
                <Leaf className="w-8 h-8 text-primary animate-bounce" />
              </div>
            </div>
          </div>

          {/* Brand Name */}
          <div className="flex items-center justify-center gap-3 mb-2">
            <h1 className="text-4xl font-bold text-white tracking-wide">Fayoz</h1>
          </div>
          <p className="text-secondary/90 text-lg font-medium">Premium Skin & Hair Care</p>
        </div>

        {/* Loading Progress */}
        <div className="w-80 mx-auto mb-8">
          <div className="bg-white/20 rounded-full h-2 overflow-hidden">
            <div
              className="bg-gradient-to-r from-secondary to-secondary/80 h-full rounded-full transition-all duration-300 ease-out"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <div className="flex justify-between text-white/70 text-sm mt-2">
            <span>0%</span>
            <span className="font-medium">{progress}%</span>
            <span>100%</span>
          </div>
        </div>

        {/* Loading Messages */}
        <div className="h-8 mb-8">
          <p className="text-white/90 text-lg font-medium animate-fade-in">{messages[currentMessage]}</p>
        </div>

        {/* Floating Elements */}
        <div className="flex justify-center gap-4">
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              className="w-3 h-3 bg-secondary rounded-full animate-bounce"
              style={{ animationDelay: `${i * 0.2}s` }}
            ></div>
          ))}
        </div>
      </div>
    </div>
  )
}
